import type { FaireProductEntity } from "../../entity_types/product";

export const p_kr3pa2unfx: FaireProductEntity = {
  token: "p_kr3pa2unfx",
  type: "product",
  name: "Tightrope",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/3f87fe54adffc26e2142f20dc6b9e526c4109809b0564f582e61ffc0a17ab6da.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/891e09576bc750533f60ed5acbc5199d6fc925a6327e87a795f0d8681d0a3298.png",
    "https://cdn.faire.com/fastly/b18f0a14afa6712290f1d8742e00e9f24df8778a576286478e680b29dfce8a50.png",
    "https://cdn.faire.com/fastly/46f7d3092965cf595a4901087946e4e0d167472cd2018f23fbaf2d1e12b7846e.png",
    "https://cdn.faire.com/fastly/57fb48795002427b53f4d506084bb2eac9e0b5da7a43c2b9ae04cee615671cd9.png",
  ],
  priceDollars: 12.77,
  description:
    'Crisp—Sweet—Clean\n\nBackstory: Tightrope is named for the challenge of balancing the lively origin character that can make coffees interesting with the body and roast character that can make them more satisfying. When we successfully walk this line, great things happen.\n\nOrigins: We like to think of Tightrope as one of our two house blends. This one is for fans of lighter, brighter, approachable coffees. Expect seasonal, washed processed coffees with clean, bright flavors.\n\nPairings: Pairs well with your daily commute and songs like Outkast\'s "So Fresh, So Clean", Johnny Cash\'s "I Walk The Line", and "Three Girl Rhumba" by Wire.\n\nBrew: Use a scale and grind fresh. Use 16 grams of water at 200°F for each gram of coffee.',
  tags: [],
  msrpDollars: 18.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:06.554Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
